
import { motion } from 'framer-motion';

export default function ContactHero() {
  return (
    <section className="relative pt-32 pb-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b63e05a3b52a70a6688c82d41caa76fb.jpg"
          alt="Yangın algılama sistemleri iletişim"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-900/85 via-gray-900/70 to-gray-900/50"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="max-w-2xl"
        >
          <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-red-600/20 border border-red-500/30 rounded-full text-red-300 text-xs font-semibold tracking-wider uppercase mb-6">
            <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
            7/24 Acil Müdahale
          </span>
          <h1 className="text-4xl lg:text-5xl font-bold text-white leading-tight mb-5">
            Bize <span className="text-red-400">Ulaşın</span>
          </h1>
          <p className="text-gray-300 text-base leading-relaxed max-w-lg">
            Yangın algılama ve güvenlik sistemleri hakkında sorularınız için bize ulaşın. Uzman ekibimiz en kısa sürede size dönüş yapacaktır.
          </p>
          <div className="flex flex-wrap gap-4 mt-8">
            <a
              href="tel:+903126660636"
              className="inline-flex items-center gap-2 px-6 py-3 bg-red-600 text-white text-sm font-semibold rounded-full hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line"></i>
              0312 666 06 36
            </a>
            <a
              href="mailto:info@yanginalgila.com"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 border border-white/20 text-white text-sm font-semibold rounded-full hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line"></i>
              info@yanginalgila.com
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
